import React from 'react';
import { correctIdString, optionIdString } from '../../utilities/CreateOptionData';

const CreateSingleOptions = ({ register, num, watch, defaultOptionText, defaultIsCorrect }) => {


    const allOptionCorrectStatus = [1, 2, 3, 4].map(single => watch(correctIdString(single)))

    const isRequire = () => allOptionCorrectStatus.every(single => Boolean(single) === false);
    return (
        <div>
            <label htmlFor={optionIdString(num)}>{optionIdString(num)}</label>

            <input defaultValue={defaultOptionText} id={optionIdString(num)} type="text" className='login-input' {...register(optionIdString(num), { required: true })} />

            <div className='flex gap-2 items-center '>
                <input type="checkbox" className='!w-auto' defaultChecked={defaultIsCorrect} id={correctIdString(num)} {...register(correctIdString(num), { required: isRequire() })} />
                <label htmlFor={correctIdString(num)} className='!w-auto font-semibold cursor-pointer'>Is Correct </label>

            </div>
        </div>
    );
};

export default CreateSingleOptions;